export interface BaseAppConfig {
  backendUrl: string
  appTitle: string
  maxAllowedTimeDifferenceWithServer: number
}

export enum AppConfigServiceErrorCodes {
  GENERIC,
  CANNOT_LOAD_FILE,
  CANNOT_PARSE_JSON,
}
